import { TelLink, TelLinkProps } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledSection = styled.section`
  margin-top: 20px;
`;

export const StyledTelLink = styled<FC<TelLinkProps>>(TelLink)`
  color: ${({ theme }) => theme.colors.blue5};
  font-weight: 600;
`;
